<template>
  <!-- 配置模板 -->
  <a-breadcrumb>
    <a-breadcrumb-item>配置管理</a-breadcrumb-item>
    <a-breadcrumb-item>商品库</a-breadcrumb-item>
  </a-breadcrumb>
  <div class="content">
    <div class="action">
      <div style="flex: 1;"></div>
      <a-button type="primary" @click="add"><plus-outlined />新增商品</a-button>
    </div>
    <div class="table-box">
      <a-table :data-source="dataSource" :columns="columns" :pagination="pagination" :row-key="record => record.id"
        :loading="isLoading" @change="handleTableChange">
        <template #bodyCell="{ column, record }">
          <!-- 操作 -->
          <template v-if="column.key === 'operation'">
            <a class="operation-item" @click="edit(record)">编辑</a>
          </template>
        </template>
      </a-table>
    </div>
  </div>
  <!-- 新增、编辑弹窗 -->
  <Add ref="RefAdd" @success="getList" />
</template>

<script setup>
import { ref, reactive, nextTick, onBeforeMount } from 'vue'
import { message } from 'ant-design-vue'
import Add from './components-products/Add.vue'
import { getgoodList } from '@/api/admin'

// 单个子组件暴露体初始化
let RefAdd = ref(null)
// 是否隐藏停用类型
let checked = ref(true)
// 数据源
let dataSource = ref(null)
// 加载
let isLoading = ref(false)
// 表头
let columns = reactive([
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '金额',
    dataIndex: 'money',
    key: 'money',
  },
  {
    title: '谷歌ID',
    dataIndex: 'google_id',
    key: 'google_id',
  },
  {
    title: '苹果ID',
    dataIndex: 'apple_id',
    key: 'apple_id',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  getList()

})

// 表格change
function handleTableChange(p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 请求分页数据
function getList() {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  getgoodList(params).then(res => {
    isLoading.value = false
    // console.log(res);

    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total

    } else {
      message.error(res.message || msg)
    }
  })
}

// 子组件新增弹窗
function add() {
  RefAdd.value.showDrawer()
}

// 编辑
function edit(record) {
  RefAdd.value.showDrawer(record)
}
</script>

<style lang="less" scoped>
.content {
  padding: 24px 0;

  .action {
    display: flex;
    margin-bottom: 16px;
  }

  .operation-item {
    margin-right: 8px;
  }
}
</style>